"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _DarkDropdownPopup = require("./DarkDropdownPopup.style");

var popupMargin = 5;

function getBoundingClientRectForNode(el, parentNode) {
  var parentPos = parentNode.getBoundingClientRect();
  var childrenPos = el.getBoundingClientRect();
  var relativePos = {
    top: childrenPos.top - parentPos.top,
    right: childrenPos.right - parentPos.right,
    bottom: childrenPos.bottom - parentPos.bottom,
    left: childrenPos.left - parentPos.left
  };
  return relativePos;
}

var calculatePosition = function calculatePosition(node, placement, givenPopupWidth, popupNode, parentNode) {
  if (!node) return {
    top: 0,
    left: 0
  };
  var el = node.firstChild;
  var top = el.offsetHeight + popupMargin;
  var left = placement.includes('Right') ? el.offsetWidth - (givenPopupWidth || _DarkDropdownPopup.popupWidth) : 0;
  top += getBoundingClientRectForNode(el, parentNode).top + parentNode.scrollTop + 4;
  var elementLeft = getBoundingClientRectForNode(el, parentNode).left;
  left += elementLeft;
  var firstChildOffsetWidth = popupNode && popupNode.firstChild ? popupNode.firstChild.offsetWidth : 0;
  left = placement.includes('Right') ? elementLeft + el.offsetWidth - firstChildOffsetWidth : left;
  return {
    top: top,
    left: left
  };
};

var _default = calculatePosition;
exports.default = _default;